<div class="company">
  <mat-icon>storefront</mat-icon>
  <span class="companyName">{{ pinConfig.companyName }}</span>
</div>

<div class="pad">
  <div class="pinfield" [class.filled]="!!pin">
    <span class="ph" *ngIf="!pin">{{ 'pinLogin.enterPin' | translate }}</span>
    <span class="dot" *ngFor="let item of pin | splitString"></span>
  </div>

  <div class="keypad">
    <button
      class="key"
      *ngFor="let button of [].constructor(9); let i = index"
      (click)="addPin(i + 1)"
    >
      {{ i + 1 }}
    </button>
    <button class="key fn" (click)="delete()">
      <mat-icon>backspace</mat-icon>
    </button>
    <button class="key" (click)="addPin(0)">0</button>
    <button
      class="key enter"
      (click)="login()"
      [disabled]="isBusy"
      [IsBusy]="isBusy"
    >
      <mat-icon>login</mat-icon>
    </button>
  </div>
</div>

<button
  class="logout"
  [disabled]="!!pin"
  (click)="confirmLogout()"
>
  <mat-icon>logout</mat-icon>
  <span>{{ 'pinLogin.logout' | translate }}</span>
</button>
